import { MAX_INPUT_LENGTH } from '@/common/const'
import { classNames } from '@/common/utils'
import { ButtonHTMLAttributes } from 'react'
import { InputHTMLAttributes, useEffect } from 'react'
import { useRef } from 'react'

export function InlineInput({
  children,
  classes,
  ...args
}: React.PropsWithChildren & {
  autoFocus?: boolean
  classes?: string
  type: React.HTMLInputTypeAttribute
} & InputHTMLAttributes<HTMLInputElement>) {
  const ref = useRef<HTMLInputElement | null>(null)
  useEffect(() => {
    if (ref?.current && args.autoFocus) {
      ref.current.focus()
    }
  })
  return (
    <input
      className={classNames('input-inline', classes)}
      maxLength={args.type == 'email' ? MAX_INPUT_LENGTH.EMAIL : undefined}
      {...args}
      ref={ref}
    />
  )
}

export function InlineInputWithLabel({
  children,
  label,
  labelFor,
  singleCol,
  ...args
}: React.PropsWithChildren & {
  label: string
  labelFor: string
  autoFocus?: boolean
  singleCol?: boolean
  type: React.HTMLInputTypeAttribute
} & InputHTMLAttributes<HTMLInputElement>) {
  return (
    <div
      className={`grid grid-cols-1 ${
        singleCol ? '' : 'md:grid-cols-2'
      } space-y-1`}
    >
      <label
        htmlFor={labelFor}
        className="text-sm flex flex-col justify-center"
      >
        {label}
      </label>
      <div className="md:mt-0">
        <InlineInput {...args} id={labelFor} name={labelFor} />
      </div>
    </div>
  )
}

type ButtonWithIconProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  isDisabled?: boolean
  color?: 'green' | 'blue' | 'red' | 'orange'
  classes?: string
  mini?: boolean
  Icon?: React.FunctionComponent<{
    className: string
  }>
}

export function ButtonWithIcon({
  Icon,
  color,
  mini,
  classes,
  children,
  isDisabled = false,

  ...args // every other generic attr like onChange, etc.
}: ButtonWithIconProps) {
  return (
    <button
      type="button"
      disabled={isDisabled}
      className={classNames(
        'btn',
        Icon && 'flex',
        color,
        classes,
        mini && 'mini'
      )}
      {...args}
    >
      {Icon && <Icon className={`w-4 h-4 ${children && 'mr-2'}`} />} {children}
    </button>
  )
}
